import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();
// Login Method
export const chatLogin = (data) => api.create(url.LOGIN, data);
// ForgetPwd
export const forgotPassword = data => api.create(url.PASSWORD_FORGET, data);
export const ResetPassword = data => api.create(url.RESET_PASSWORD, data);

//update and fetch admin profile
export const editUser = (id, data) => api.put(`${url.EDIT_USER}/${id}`, data);
export const fetchProfile = (data) => api.get(url.FETCH_PROFILE, data)
//users
export const updateCandidateStatus = (data) =>api.put(`${url.UPDATE_CANDIDATE_STATUS}/${data.id}`, { status: data.status });
export const deleteCandidate = (data) => api.delete(url.DELETE_CANDIDATE, data);
export const bulkDeleteCandidate = (data) => api.create(url.BULK_DELETE_CANDIDATE, data);
export const getCandidateWithFilter = (data) => api.get(url.GET_CANDIDATE_WITH_FILTER , data);


export const updateCategoryStatus = (data) =>   api.put(`${url.UPDATE_CATEGORY_STATUS}/${data.id}`, data.payload);

export const deleteCategory = (data) =>
  api.delete(`${url.DELETE_CATEGORY}/`,data.id);
export const bulkDeleteCategory= (data) => api.create(url.BULK_DELETE_CATEGORY, data);
export const getCategoryWithFilter = (data) => api.get(url.GET_CATEGORY_WITH_FILTER , data);
export const getCategoryWithIDS = (id) => api.get(`${url.GET_CATEGORY_ID}/${id}`);
export const createCategory = (data) => api.acreate(url.CREATE_CATEGORY , data);
export const getCategoryWithPage = (data) => api.get(url.GET_CATEGORY_WITH_PAGE , data);

export const updateQuestion = (data) =>api.put(`${url.UPDATE_QUESTION}/${data.id}`, data.payload);
export const deleteQuestion = (data) =>api.delete(`${url.DELETE_QUESTION}/`,data.id);    
export const bulkDeleteQuestion= (data) => api.create(url.BULK_DELETE_QUESTION, data);
export const getQuestionWithFilter = (data) => api.get(url.GET_QUESTION_WITH_FILTER, data);
export const getQuestionWithIDS = (data) =>  api.get(`${url.GET_QUESTION_ID}/${data}`);
export const createQuestion = (data) => api.acreate(url.CREATE_QUESTION , data);
export const getQuestionPage = (data) => api.get(url.GET_QUESTION_PAGE , data);


export const updateQuize = (data) => {
  // Log the payload before sending the request
  console.log("📦 Payload being sent:", data);

  // Send the PUT request
  return api.put(`${url.UPDATE_QUIZE}/${data.id}`, data);
};

export const deleteQuize = (data) =>api.delete(`${url.DELETE_QUIZE}/`,data.id);    
export const bulkDeleteQuize= (data) => api.create(url.BULK_DELETE_QUESTION, data);
export const getQuizeWithFilter = (data) => api.get(url.GET_QUIZE_WITH_FILTER, data);
export const getQuizeWithIDS = (data) => api.get(`${url.GET_QUIZE_ID}/${data}`);
export const createQuize = (data) => api.acreate(url.CREATE_QUIZE, data);
export const   fetchQuizeWithPage=(data) => api.get(url.GET_QUIZE_WITH_PAGE,data);



// export const deleteCandidateResult = (data) => api.delete(`${url.DELETE_CANDIDATE_RESULT}/`, data.id);

// export const bulkDeleteCandidateResult = (data) => api.create(url.BULK_DELETE_CANDIDATE_RESULT, data);

  export const getCandidateResultWithFilterPage = (data) => api.get(url.GET_CANDIDATE_TEST_RESULT_PAGE, data);

export const getCandidateResultWithId = (data) => api.get(`${url.GET_CANDIDATE_RESULT_ID}/${data}`);
export const getAllCandiateWithFilter=(data) => api.get(url.GET_CANDIDATE_TEST_WITH_FILTER, data);
// export const createCandidateResult = (data) => api.acreate(url.CREATE_CANDIDATE_RESULT, data);





export const generateRandom=(data) => api.acreate(url.GENERATE_RANDOM, data);
export const deleteSetting = (id) => api.delete(`/settings/${id}`);
// export const bulkDeleteSetting = (data) => api.create(url.BULK_DELETE_SETTING, data);
export const getSettingWithFilter = (data) => api.get(url.GET_SETTING_RESULT_WITH_FILTER, data);
export const getSettingWithIDS = (data) => api.get(`${url.GET_SETTING_RESULT_ID}/${data}`);

// Settings API helpers (clean, correct endpoints)
export const fetchSettings = () => api.get('/settings');
export const fetchSettingById = (id) => api.get(`/settings/${id}`);
export const createSetting = (data) => api.acreate('/settings', data);
export const updateSetting = (id, data) => api.put(`/settings/${id}`, data);
